export { default } from './ExtraText';
export * from './ExtraText.types';
